import { PlansPlanMode } from '../../../api/types'
import {
  isListPlansFetchFailed,
  isListPlansLoading,
  useLumpsumPlansContext
} from '../../LumpsumPlansProvider'
import { PlansCategoryListSkeleton } from '../../lumpsum-ui-components/PlansCategoryListSkeleton'
import { AllocationBlurredBody } from './AllocationBlurredBody'
import { AllocationCategoryList } from './AllocationCategoryList'
import { AllocationPlansListErrorState } from './AllocationPlansListErrorState'

/** Rolled-out allocation body: locked (not Prime) or full list. */
export function LumpsumAllocationBody() {
  const { allocationPlansData, allocationPlansQuery } = useLumpsumPlansContext()

  if (isListPlansLoading(PlansPlanMode.ALLOCATION, allocationPlansQuery)) {
    return <PlansCategoryListSkeleton />
  }

  if (isListPlansFetchFailed(PlansPlanMode.ALLOCATION, allocationPlansQuery)) {
    return <AllocationPlansListErrorState onRetry={allocationPlansQuery.refetch} />
  }

  if (allocationPlansData?.isPlanSubscriptionEligible !== true) {
    return <AllocationBlurredBody />
  }

  return <AllocationCategoryList />
}
